import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DailyScheduleCard = ({ scheduleItems, onReschedule, onViewDetails }) => {
  const getStatusColor = (status) => {
    const statusColors = {
      upcoming: 'bg-primary/10 text-primary',
      inProgress: 'bg-success/10 text-success',
      completed: 'bg-muted text-muted-foreground',
      cancelled: 'bg-error/10 text-error',
    };
    return statusColors?.[status] || statusColors?.upcoming;
  };

  const getTypeIcon = (type) => {
    const typeIcons = {
      personal: 'User',
      class: 'Users',
      availability: 'Clock',
    };
    return typeIcons?.[type] || 'Calendar';
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Calendar" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Today's Schedule</h2>
            <p className="text-sm text-muted-foreground">Saturday, January 25, 2026</p>
          </div>
        </div>
        <Button variant="outline" iconName="Plus" iconPosition="left">
          Add Session
        </Button>
      </div>
      <div className="space-y-3">
        {scheduleItems?.map((item) => (
          <div
            key={item?.id}
            className="flex flex-col lg:flex-row lg:items-center gap-4 p-4 rounded-lg border border-border hover:border-primary/50 transition-all duration-250 bg-card"
          >
            <div className="flex items-center gap-4 flex-1 min-w-0">
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon name={getTypeIcon(item?.type)} size={20} color="var(--color-primary)" />
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-base font-medium text-foreground truncate">{item?.title}</h3>
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(item?.status)}`}>
                    {item?.status === 'inProgress' ? 'In Progress' : item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)}
                  </span>
                </div>
                <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Clock" size={14} />
                    {item?.time}
                  </span>
                  {item?.client && (
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={14} />
                      {item?.client}
                    </span>
                  )}
                  {item?.location && (
                    <span className="flex items-center gap-1">
                      <Icon name="MapPin" size={14} />
                      {item?.location}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                variant="ghost"
                size="sm"
                iconName="Eye"
                onClick={() => onViewDetails(item?.id)}
              >
                View
              </Button>
              {item?.status === 'upcoming' && (
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Calendar"
                  onClick={() => onReschedule(item?.id)}
                >
                  Reschedule
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DailyScheduleCard;